import { render, staticRenderFns } from "./GlyanecEuroBusinessCard.vue?vue&type=template&id=ddaaaebe&scoped=true&"
import script from "./GlyanecEuroBusinessCard.vue?vue&type=script&lang=js&"
export * from "./GlyanecEuroBusinessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaaaebe",
  null
  
)

export default component.exports